import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { QUOTE_TYPES, SRC_IDS } from '@Helpers/surehits';
import SureHits from '../../Components/SureHits';

const MyPersonalQuote = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [leadSource, setLeadSource] = useState('');
    const [formData, setFormData] = useState(() => {
        const savedFormData = localStorage.getItem('formData');
        return savedFormData ? JSON.parse(savedFormData) : location.state?.formData || {};
    });

    useEffect(() => {
        let passedFormData = sessionStorage.getItem('formData') && JSON.parse(sessionStorage.getItem('formData'));
        sessionStorage.removeItem('formData');
        if (!passedFormData) {
            passedFormData = location.state?.formData || {};
        } else {
            setTimeout(() => navigate(null, { replace: true, state: { formData: passedFormData } }), 1);
        }
        if (passedFormData) {
            const passedType = passedFormData?.insurance_types?.[0]?.type;
            setLeadSource(SRC_IDS[passedType] || SRC_IDS.auto);
            setFormData(passedFormData);
        }
        const myQuoteElement = document.getElementById('my-quote');
        if (myQuoteElement) {
            myQuoteElement.classList.add('step4');
            myQuoteElement.classList.add('personal-insurance');
            myQuoteElement.style.minHeight = '0'; // Remove the minHeight set in the CSS as it needs to load close to surehits
        }
    }, []);

    return (
        <form className="personal-insurance-container">
            <p className="disclosure-label">Important Advertising Disclosure Below</p>
            {/* Removed copy per CI-3747 */}
            {leadSource && (
                <SureHits
                    type={QUOTE_TYPES.PERSONAL}
                    leadSource={leadSource}
                    useFormData={() => [formData, setFormData]}
                >
                    <div className="external-disclosure-container">
                        <label className="external-disclosure-text">
                            <strong>Disclaimer:</strong> The results provided on this page are through
                            http://Insure.com, and may include advertising from partners for which http://Insure.com
                            and/or Tivly receives compensation ("Sponsors"). Compensation may impact where the Sponsors
                            appear on this page (including the order in which they appear). The results on this page do
                            not, and are not intended to, provide a comprehensive list of all companies that may provide
                            the products and services you are seeking.
                        </label>
                    </div>
                </SureHits>
            )}
        </form>
    );
};

export default MyPersonalQuote;
